<script>
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "SelectInput",
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        prop: "",
        value: "",
      }),
    },
    options: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, context) {
    const { t } = useI18n();

    //event
    const onSelectChange = (val) => {
      context.emit("update:modelValue", {
        prop: val,
        value: props.modelValue.value,
      });
    };
    const onInputChange = (val) => {
      context.emit("update:modelValue", {
        prop: props.modelValue.prop,
        value: val.trim(),
      });
    };
    return () => (
      <div class="select-input">
        <el-select
          class="select"
          placeholder={t("commonTipSelect")}
          modelValue={props.modelValue.prop}
          onChange={onSelectChange}
          clearable
        >
          {props.options.map((item) => {
            return (
              <el-option
                key={item.value}
                label={item.label}
                value={item.value}
              ></el-option>
            );
          })}
        </el-select>
        <el-input
          placeholder={t("commonTipInput")}
          class="input"
          clearable
          modelValue={props.modelValue.value}
          onInput={onInputChange}
        />
      </div>
    );
  },
});
</script>
<style lang="scss" scoped>
.select-input {
  display: flex;
  width: 100%;
  .select {
    width: 120px;
    max-width: 140px;
    min-width: 100px;
    margin-right: 5px;
    flex: 0 1 auto;
  }
  .input {
    flex: 1 1 auto;
  }
}
</style>
